import AssistivLogoSVG from '@/assets/branding/assistiv/assistiv-new.svg';
import AssistivLogoSmallSVG from '@/assets/branding/assistiv/assistiv-new-small.svg';

export { AssistivLogoSVG, AssistivLogoSmallSVG };
